<div id="{{idElement}}" class="content">
  <img id="iconSuccess" *ngIf="type === 'success'" class="ic-type" src="assets/images/icon/ic_success.svg" />
  <img id="iconFailed" *ngIf="type === 'failed'" class="ic-type" src="assets/images/icon/ic_incomplete.svg" />
  <img id="iconRemark" *ngIf="type === 'remark'" class="ic-type" src="assets/images/icon/ic_remark_greeny_blue.svg" />
  <img id="iconVasFailed" *ngIf="type === 'vas-failed'" class="ic-type" src="assets/images/icon/ic_vas_fail.svg" />
  <ng-content></ng-content>
</div>
